<template>
	<validation-observer v-slot="{handleSubmit}" ref="formValidator">
		<b-form role="form" class="tw-mt-7" @submit.prevent="handleSubmit(onSubmit)">
			<!-- Expert -->
			<base-input
				alternative
				name="perito"
				label="Perito"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				v-model="assignment.perito"
				@input="errorMessage = null"
			>
				<multiselect
					label="name"
					track-by="id"
					close-on-select
					:options="$experts"
					placeholder="Seleccionar perito"
					v-model="assignment.expert"
				></multiselect>
			</base-input>

			<!-- Random Selection -->
			<base-input
				alternative
				class="tw-mt-3"
				name="random-selection"
				label="Seleccion"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				v-model="assignment.randomSelection"
			>
				<div class="tw-bg-white tw-px-2 tw-rounded-md tw-py-2">
					<b-form-checkbox
						switch
						name="random-selection"
						class="tw-font-medium tw-text-sm tw-text-gray-700"
						v-model="assignment.randomSelection"
					>Seleccion Aleatoria</b-form-checkbox>
				</div>
			</base-input>

			<!-- Client -->
			<base-input
				alternative
				name="client"
				label="Cliente"
				class="tw-mt-3"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese Cliente"
				v-model="assignment.client"
				@input="errorMessage = null"
			/>

			<!-- Phone -->
			<base-input
				alternative
				name="phone"
				type="tel"
				class="tw-mt-3"
				label="Telefono"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese Telefono"
				v-model="assignment.phone"
				@input="errorMessage = null"
			/>

			<!-- Ciudad -->
			<base-input
				alternative
				name="town"
				label="Ciudad"
				class="tw-mt-3"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				:rules="{ required: true }"
				placeholder="Ingrese Ciudad"
				v-model="assignment.town"
				@input="errorMessage = null"
			/>

			<!-- Appraisal Type -->
			<base-input
				alternative
				class="tw-mt-3"
				name="appraisalType"
				label="Tipo de Avaluo"
				:rules="{ required: true }"
				label-classes="tw-px-3 tw-mb-1"
				placeholder="Ingrese tipo de Avaluo"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				v-model="assignment.appraisalType"
				@input="errorMessage = null"
			/>

			<!-- Location -->
			<base-input
				alternative
				class="tw-mt-3"
				name="location"
				label="Selecciona Ubicacion"
				:rules="{ required: true }"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				v-model="assignment.location"
				@input="errorMessage = null"
			>
				<div class="tw-bg-white tw-p-2 tw-rounded-md">
					<location-picker expanded-modal class="tw--mt-1" v-model="assignment.location" />
				</div>
			</base-input>

			<!-- Documents -->
			<base-input
				alternative
				class="tw-mt-3"
				label-classes="tw-px-3 tw-mb-1"
				group-class="mb-0 tw-bg-white tw-rounded tw-bg-opacity-60"
				name="documents"
				label="Agregar Documentos"
				:rules="{ required: true }"
			>
				<b-form-file
					multiple
					:state="Boolean(assignment.documents)"
					:value="assignment.documents[0]"
					@input="assignment.documents=$event"
					placeholder="Choose a file or drop it here..."
					drop-placeholder="Drop file here..."
					class="tw-border-none"
				></b-form-file>
			</base-input>

			<document-list>
				<document-list-item
					v-for="(doc, docIndex) in assignment.documents"
					:key="docIndex"
					:document="doc"
					:loading="loading"
					:uploading="!uploaded.includes(doc.name)"
					@remove="assignment.documents.splice(docIndex, 1)"
				/>
			</document-list>

			<div class="tw-flex tw-justify-between my-4">
				<base-button
					type="secondary"
					native-type="submit"
					:loading="loading"
				>{{isUpdating ? 'Update Perito' : 'Crear Perito'}}</base-button>
				<base-button type="danger" v-if="isUpdating" @click="onResetForm">Cancel</base-button>
			</div>
		</b-form>
	</validation-observer>
</template>

<script>
import { STATUS } from '../../consts'
import { mapActions, mapGetters } from 'vuex'
import { AssignmentsAPI } from '../../firebase/api.firebase'

import Multiselect from 'vue-multiselect'
import DocumentList from '../../components/DocumentList.vue'
import DocumentListItem from '../../components/DocumentListItem.vue'

const initialAssignment = (v = {}) => {
	return {
		status: STATUS.ASSIGNED,
		expert: null,
		randomSelection: false,
		client: v.client || '',
		phone: v.phone || '',
		town: v.town || '',
		appraisalType: v.appraisalType || '',
		location: v.location || {},
		documents: v.documents || []
	}
}

export default {
	name: 'AssignmentForm',
	components: {
		Multiselect,
		DocumentList,
		DocumentListItem,
	},
	data: () => ({
		// Booleans
		loading: false,
		isUpdating: false,

		// Objects
		assignment: initialAssignment(),

		// Arrays
		uploaded: []
	}),
	created() {
		this.subscribeExperts()
	},
	computed: {
		...mapGetters('assignments', [
			'$experts'
		])
	},
	methods: {
		...mapActions('assignments', [
			'subscribeExperts',
			'createAssignment'
		]),
		onResetForm() {
			this.isUpdating = false
			this.$refs.formValidator.reset()
			this.assignment = initialAssignment()
		},
		async onSubmit() {
			this.loading = true

			if (this.isUpdating) {
				await this.assignmentRef.update(this.assignment)
			}
			else {
				const documents = await AssignmentsAPI
					.uploadFiles(this.assignment.documents, (_, file) => {
						this.uploaded.push(file.name)
					})
				await this.createAssignment({
					...this.assignment, documents,
					expert: {
						id: this.assignment.expert.id,
						name: this.assignment.expert.name
					},
				})
			}
			this.loading = false
			this.onResetForm()
		}
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
